export default {
    confirm: '保存',
    helpText: '{{type}}へ変換する際は、各項目の設定方法を選んでください。',
    messagesLabel: '備考',
    notesLabel: 'メモ',
    options: {
        copyFromPreset: '書類定型パターンの内容を適用',
        copyFromSource: '変換元書類の内容をコピー',
        leaveBlank: '空欄',
    },
    title: '書類の変換設定',
};
